import * as types from './mutation-types'
import {SAVE_RESTAURANT} from "./mutation-types";

export const loadRestaurant = ({ commit, dispatch, state },data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('customer/get/restaurant',).then((response) => {
            commit(types.LOAD_RESTAURANT, response.data.data)
            commit(types.SAVE_RESTAURANT)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}




